import { Outlet, type RouteObject } from 'react-router-dom';

import { UnauthenticatedLayout } from '../layouts';
import { LoginPage } from '../pages/auth/login';
import { LogoutPage } from '../pages/auth/logout';
import { MagicLinkPage } from '../pages/auth/magic-link';

export const authRoutes: RouteObject = {
  path: 'auth',
  element: (
    <UnauthenticatedLayout>
      <Outlet />
    </UnauthenticatedLayout>
  ),
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'logout',
      element: <LogoutPage />,
    },
    {
      path: 'magic-link',
      element: <MagicLinkPage />,
    },
  ],
};
